import { connect } from 'react-redux';
import Component from '../../components/login-form/step-totp-invalid';

import { resetForm } from '../../modules/auth-data';

export default connect(null, {
  resetForm,
})(Component);
